import React, { Component } from "react";
import { connect } from "react-redux";
import SlaveTempChartWrap from "./wrapper/slave-temp-chart-wrapper";
const mapStateToProps = (state = {}) => {
  return { ...state };
};

// Assuming SlaveEMSData is the state containing EMS data
class SlaveTempChart extends Component {

  constructor(props) {
    super(props);

  }


  render() {
    
    var {cellEMSData }= this.props
    var slaveTempArr=[]
    var slaveNoArr = []
    var slaveNo=1;

    if(Object.keys(cellEMSData).length > 0){
    cellEMSData['slaves'].forEach(slave => {

        slaveTempArr.push(slave['SCT'])
        slaveNoArr.push(slaveNo)
        slaveNo++
    });
    console.log("Each EMS Data through Slave Temp",slaveTempArr,slaveNoArr)
    return (
      <SlaveTempChartWrap 
      slaveTempArr ={slaveTempArr}
      slaveNoArr={slaveNoArr}
      style={{ padding: "10px", margin: "10px" }}
      />
    );
    } else {
      return <div style={{ padding: "10px", margin: "10px" }}>No Real Time Slave Data Available</div>
    }
  }
}
export default connect(mapStateToProps)(SlaveTempChart);
